<template>
	<div class="companyInfo" >
		<div class="header_ContentBox p-l-10 p-r-10">
			<i class="zb zb-enterprise Icon"></i>
			<!-- <span class="p-l-10 p-r-10">/</span> -->
			<span class="header_text">/ 企业管理 / 企业信息资料</span>
		</div>
		<div class="companybox content_Box box-shadow m-t-15 p-l-10 p-r-10" :style="{'min-height': windowSizeHeight-120 +'px'}">
			<div class="headerBox">
				基本信息
			</div>
			<div>
				<div class="row-info clear">
					<div class='fl title-key'>企业名称</div>
					<div class='fl list-cont'>{{enterpriseInfo.enterprise_name}}</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'>营业执照注册号</div>
					<div class='fl list-cont'>{{enterpriseInfo.unified_credit_code}}<b class="hintSelect">（统一社会信用代码）</b></div>
					
				</div>
				<div class="row-info clear">
					<div class='fl title-key'>企业规模</div>
					<div class='fl list-cont'>
						<el-radio-group v-model="enterpriseInfo.enterprisescale" size="small">
							<el-radio-button label="1">50人以下</el-radio-button>
							<el-radio-button label="2">50-100人</el-radio-button>
							<el-radio-button label="3">100-300人</el-radio-button>
							<el-radio-button label="4">300-500人</el-radio-button>
							<el-radio-button label="5">500人以上</el-radio-button>
						</el-radio-group>
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'><i class="zb zb-asterisk"></i>所属行业</div>
					<div class='fl list-cont'>
						<el-select filterable v-model="enterpriseInfo.industry" placeholder="请选择">
							<el-option v-for="item in industryArr" :key="item.name" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
						<b class="hintSelect">（请如实选择）</b>
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'><i class="zb zb-asterisk"></i>联系地址</div>
					<div class='fl list-cont'>
						<el-input v-model="enterpriseInfo.contact_address"  placeholder="请输入内容"></el-input>
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'><i class="zb zb-asterisk"></i>联系电话</div>
					<div class='fl list-cont'>
						<el-input v-model="enterpriseInfo.contact_number2" placeholder="请输入内容"></el-input>
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'><i class="zb zb-asterisk"></i>项目负责人</div>
					<div class='fl list-cont'>
						<el-input v-model="enterpriseInfo.personincharge" placeholder="请输入内容"></el-input>
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'><i class="zb zb-asterisk"></i>电子邮箱</div>
					<div class='fl list-cont'>
						<el-input v-model="enterpriseInfo.email" placeholder="请输入内容"></el-input>
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'> 公司网址</div>
					<div class='fl list-cont'>
						<el-input v-model="enterpriseInfo.enterprise_website" placeholder="请输入内容"></el-input>
					</div>
				</div>
				<div class="submitBox clear">
					<span class="btnOK" @click="EnterpriseUpdate">保 存</span>
				</div>
			</div>
			<div class="headerBox">
				资质材料
			</div>
			<div class="">
				<div class="row-info clear">
					<div class='fl title-key'>营业执照扫描件</div>
					<div class='fl list-cont'>
						<img style="height: 100px;" :src="business_license" alt="无" title="点击查看原图" @click="openMaxImg(business_license)">
												
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'>法人身份证</div>
					<div class='fl list-cont'>
						<img style="height: 100px;" v-if="idcard_positive" :src="idcard_positive" alt="无" title="点击查看原图" @click="openMaxImg(idcard_positive)">
						<img style="height: 100px;" v-if="idcard_back" :src="idcard_back" alt="无" title="点击查看原图" @click="openMaxImg(idcard_back)">						
					</div>
				</div>
				<div class="row-info clear">
					<div class='fl title-key'>开户许可证</div>
					<div class='fl list-cont'>
						<img style="height: 100px;" v-if="accountopening_permit" :src="accountopening_permit" alt="无" title="点击查看原图" @click="openMaxImg(accountopening_permit)">					
					</div>
				</div>
				<div class="clear"></div>
			</div>
			
		</div>
		<el-dialog title="图片预览" :visible.sync="dialogVisible" width="740px" :close-on-click-modal="false">
			<div style="text-align: center;">
				<el-image style="width: 100%;" id="img90" :src="dialogVisibleImg"></el-image>
			</div>
			<span slot="footer" class="dialog-footer">
				<span class="greenBtn" @click="rotateImg(1)" style="z-index: 9999;">
					<i class="zb zb-xiangzuoxuanzhuan" style="font-size: 16px;"></i>
				</span>
				<span class="greenBtn" @click="rotateImg(2)" style="z-index: 9999;">
					<i class="zb zb-xiangyouxuanzhuan" style="font-size: 16px;"></i>
				</span>
				<span class="blueBtn" @click="dialogVisible = false">关 闭</span>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	import {
		publicData
	} from '../assets/js/data.js';
	export default {
		name: 'companyInfo',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
				enterpriseInfo: '', //企业信息
				industryArr: publicData.industryArr, //行业集合
				signRateArr:[
					{
						start:'0',
						end:'',
						rate:''
					}
				],//  签约费率区间
				business_license: '', //营业执照
				accountopening_permit: '', //开户许可证
				idcard_positive: '', //身份证正面
				idcard_back: '', //身份证反面
				dialogVisible: false, //图片放大
				dialogVisibleImg: '', //放大的图片地址
				rotateNumber:0, //大图旋转
				
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {
				if (!sessionStorage.getItem('userInfo')) { //是否登录
					window.location = 'login.html';
					return;
				}
				this.getEnterpriseOne();
				this.getAptitudeImg();
			},
			getEnterpriseOne() { //获取企业信息
				this.$http.post(this.url + '/zhongfy/company/EnterpriseOne').then((res) => {
					if (res.data.msg == '成功' || res.data.code == '200') {
						let enterpriseInfo = res.data.data;
						if(enterpriseInfo.enterprise_website == null){
							enterpriseInfo.enterprise_website = '';
						}
						let contract_rate = JSON.parse(enterpriseInfo.contract_rate);
						for(let i = 0 ;i< contract_rate.length ; i++){
							contract_rate[i].rate = (contract_rate[i].rate*100).toFixed(2);
						}
						enterpriseInfo.contract_rate = contract_rate;
						this.signRateArr= contract_rate;
						this.enterpriseInfo = enterpriseInfo;
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			
			EnterpriseUpdate() { //保存修改
				if (
					this.enterpriseInfo.industry == '' ||
					this.enterpriseInfo.contact_address == '' ||
					this.enterpriseInfo.contact_number2 == '' ||
					this.enterpriseInfo.personincharge == '' ||
					this.enterpriseInfo.email == ''
				) {
					this.$message.error('请填写必填项！');
					return;
				}
				let fn = new FormData();
				fn.append('enterprisescale', this.enterpriseInfo.enterprisescale); //企业规模
				fn.append('industry', this.enterpriseInfo.industry); //所属行业
				fn.append('contact_address', this.enterpriseInfo.contact_address); //联系地址
				fn.append('contact_number2', this.enterpriseInfo.contact_number2); //联系电话
				fn.append('email', this.enterpriseInfo.email); //电子邮箱
				fn.append('personincharge', this.enterpriseInfo.personincharge); //项目负责人	
				fn.append('enterprise_website', this.enterpriseInfo.enterprise_website); //公司网址
				this.$http.post(this.url + '/zhongfy/company/EnterpriseUpdate', fn).then((res) => {
					if (res.data.msg == '修改成功' || res.data.code == '200') {
						this.getEnterpriseOne();
						this.$message.success('修改成功');
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			
			getAptitudeImg() { //获取企业图片
				this.$http.post(this.url + '/zhongfy/company/AptitudeImg').then((res) => {
					if (res.data.msg == '成功' || res.data.code == '200') {
						let data = res.data.data;
						this.business_license = data.business_license; //营业执照
						this.accountopening_permit = data.accountopening_permit; //开户许可证
						this.idcard_positive = data.idcard_positive; //身份证正面
						this.idcard_back = data.idcard_back; //身份证反面
						
					} else if (res.data.code == '8886') { //code   8886  登录过期
						sessionStorage.clear();
						this.$alert('登录已过期，请重新登录 !', '提示', {
							confirmButtonText: '确定',
							callback: action => {
								window.location = 'login.html';
							}
						});
						return;
					} else {
						this.$message.error(res.data.msg);
					}
				}, (res) => {
					this.$message.error('网络错误！');
					return;
				})
			},
			
			openMaxImg(url) { //点击放大
				this.dialogVisible = true;
				this.dialogVisibleImg = url;
				$("#img90").css({ transform:'rotate(0deg)',width:"700px",height:'auto' });
			},
			rotateImg(type){  //旋转图片
				if(type==1){
					let num = 90;
					this.rotateNumber -= num;
					if(this.rotateNumber == -360){
						this.rotateNumber = 0;
					}
					if( this.rotateNumber == -90 || this.rotateNumber == -270 || this.rotateNumber == 90 || this.rotateNumber == 270  ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',height:"700px",width:'auto' });
						
					}
					if( this.rotateNumber == -180 || this.rotateNumber == 180 || this.rotateNumber == 0 ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',width:"700px",height:'auto' });
					}
				}else if(type==2){
					let num = 90;
					this.rotateNumber += num;
					if(this.rotateNumber == 360){
						this.rotateNumber = 0;
					}
					if(this.rotateNumber == -90 || this.rotateNumber == -270 || this.rotateNumber == 90 || this.rotateNumber == 270 ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',height:"700px",width:'auto' });
						
					}
					if( this.rotateNumber == -180 || this.rotateNumber == 180 || this.rotateNumber == 0 ){
						$("#img90").css({ transform:'rotate('+this.rotateNumber+'deg)',width:"700px",height:'auto' });
					}
				}
			},
		},
		filters: {
			
		}
	}
</script>

<style scoped>
	.companybox .headerBox {
		height: 35px;
		line-height: 35px;
		font-size: 16px;
		padding-left: 10px;
		border-bottom: 1px solid #E8E8E8;
		font-weight: 700;
		color: #333333;
	}

	.submitBox {
		padding-top: 30px;
		height: 50px;
		padding-left: 100px;
	}

	.hintSelect {
		font-weight: 400;
		font-style: normal;
		font-size: 12px;
		color: #555555;
	}


	.row-info{
		padding:5px 0;
	}
	.list-cont img{
		padding: 5px ;
		border: 2px solid #CCCCCC;
	}
	@media (max-width:767.78px) {
		.contentInfo ul li>span {
			width: 80px !important;
			font-size: 10px !important;
		}

		.contentInfo .hintSelect {
			display: none !important;
		}

		.contentInfo ul li p {
			font-size: 14px;
		}

		.companyPopulation {
			width: 200px;
		}




	}
</style>



// WEBPACK FOOTER //
// src/components/IdentityCompanyInfo.vue